import GlobalContext, { GlobalProvider } from "./GlobalProvider";

export default GlobalContext;
export { GlobalProvider };
